module.exports = __webpack_public_path__ + "img/Maskgroup.68e72f8a.png";